// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterList_root__2p2hH","is-active":"FilterList_is-active__253Hn","title":"FilterList_title__1yCtG"};